<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right" *ngIf="!showSearch">
        <div class="ir-btn th-btn-modal" (click)="updateShowSearch()">
          <i class="material-icons">search</i>
        </div>
      </div>
      <div class="ir-line" *ngIf="!showSearch">
        <div class="ir-line-content">
          <span *ngIf="inspections">{{ 'plugins.associate-equipment.select-inspection' | translate }}</span>
        </div>
      </div>
      <div class="ir-line th-header-search" *ngIf="showSearch">
        <div class="ir-line--left">
          <div class="ir-btn th-btn-unactive">
            <i class="material-icons">search</i>
          </div>
        </div>
        <div class="ir-line--right">
          <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div class="ir-line-content">
          <input autoFocus type="search" name="Search" placeholder="Search" [(ngModel)]="query" focus="showSearch" />
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer">
      <div class="ir-content--modal th-content">
        <span *ngIf="loading">loading...</span>
        <div class="ir-item-line th-filter-modal" *ngIf="inspections?.length">
          <div (click)="setOrderBy('customerName')" class="ir-item-cell s4 clickable">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              {{ 'inspections.customer' | translate }}
            </span>
          </div>
          <div (click)="setOrderBy('equipementType')" class="ir-item-cell s3 clickable">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              {{ 'inspections.equipement-type' | translate }}
            </span>
          </div>
          <div (click)="setOrderBy('serial')" class="ir-item-cell s3 clickable">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              {{ 'inspections.equipement' | translate }} #
            </span>
          </div>
        </div>
        <div
          class="ir-content-flow has-filter th-content-flow--dark has-footer"
          [ngClass]="inspections?.length ? 'has-filter' : ''"
        >
          <div *ngIf="inspections">
            <div
              class="ir-item-line th-inspection clickable indent"
              [ngClass]="inspection.selected ? 'selected' : ''"
              (click)="selectInspection(inspection)"
              *ngFor="let inspection of inspections | orderBy: orderByFieldName:direction | searchBy: query"
            >
              <div class="ir-item-cell s4">
                <div class="ir-item-selector">
                  <i class="material-icons" *ngIf="!inspection.selected">check_box_outline_blank</i>
                  <i class="material-icons" *ngIf="inspection.selected">check_box</i>
                </div>
                <span>{{ inspection?.customerName ? inspection?.customerName : '&nbsp;' }}</span>
              </div>
              <div class="ir-item-cell s3">
                <span>{{ inspection?.getEquipementType() }}</span>
              </div>
              <div class="ir-item-cell s3">
                <span>{{ inspection?.getSerialNumber() }}</span>
              </div>
            </div>
          </div>
          <div class="ir-item-empty ir-mv8" *ngIf="inspections?.length == 0">
            <p>
              <span>{{ 'inspections.no-inspections' | translate }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.back' | translate }}</span>
          </div>
        </div>

        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="addInspections()"
            *ngIf="selectedInspections && selectedInspections.length > 0 && !createProcessing"
          >
            <span>{{ 'common.add' | translate }} &laquo; {{ selectedInspections?.length }} &raquo;</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="createProcessing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            *ngIf="!selectedInspections || selectedInspections.length == 0"
          >
            <span>{{ 'plugins.associate-equipment.select-equipment' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
